<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
    <div class="grid form-group">
      <!-- VINVULACIONES -->
      <div class="col-6">
        <div class="div-form">
          <label
            >*
            {{
              "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_VINCULACIONES"
                | translate
            }}</label
          >
          <p-multiSelect
            id="vinculaciones"
            name="vinculaciones"
            [options]="listaVinculaciones"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsVinculaciones"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsVinculaciones.invalid"
          >
            {{
              "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_VINCULACIONES"
                | translate
            }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <!-- PERFILES DE RIESGO -->
      <div class="col-6">
        <div class="div-form">
          <label
            >*
            {{
              "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_PERFILESRIESGO"
                | translate
            }}</label
          >
          <p-multiSelect
            id="perfilesRiesgos"
            name="perfilesRiesgos"
            [options]="listaPerfilesRiesgo"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsPerfilesRiesgos"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsPerfilesRiesgos.invalid"
          >
            {{
              "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_PERFILESRIESGO"
                | translate
            }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- BOTON AGREGAR -->
    <div class="grid text-center" *ngIf="!guardando">
      <div class="form-group col-12">
        <button
          icon="fa fa-plus"
          label="{{ 'BTN_AGREGAR' | translate }}"
          type="button"
          (click)="onSubmit()"
          pButton
        ></button>
      </div>

      <div class="grid" *ngIf="guardando">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_PROCESANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <!-- BUSCADOR -->
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6"></div>
    <div class="col-12 md:col-6 lg:col-6">
      <input
        #gb
        type="text"
        pInputText
        size="40"
        placeholder="{{ 'LBL_BUSCAR' | translate }}"
        (input)="dt.filterGlobal($event.target.value, 'contains')"
      />
    </div>
  </div>

  <!-- LISTADO Restricciones Perfil por Vinculación -->
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        #dt
        [value]="lisRestriccionesPerfilXVinculacion"
        selectionMode="single"
        dataKey="idPorcentajesLaboresCulturalesInsumos"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
        [loading]="guardando"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.tipoVinculacion }}</td>
            <td>{{ row.perfilRiesgo }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_INHABILITAR' | translate }}"
                  pButton
                  (click)="inhabilitar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="form-paso-flujo-restriccion-{{ tabView.codigo }}">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
